import { render } from "./PVProductionComponent.vue?vue&type=template&id=e9b3dfc4&scoped=true&ts=true"
import script from "./PVProductionComponent.vue?vue&type=script&lang=ts"
export * from "./PVProductionComponent.vue?vue&type=script&lang=ts"

import "./PVProductionComponent.vue?vue&type=style&index=0&id=e9b3dfc4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b3dfc4"]])

export default __exports__